import { BetEntry, RouletteScene } from '../scenes/RouletteScene';
import { GameConfig } from '../utils/GameConfig';

export class BetManager {
	private scene: RouletteScene;
	private bets: BetEntry[];

	constructor(scene: RouletteScene) {
		this.scene = scene;
		this.bets = [];
		this.initializeBets();
	}

	// Inicializa todas as apostas
	private initializeBets() {
		this.bets = [];
	}

	// OLD
	private getNumbersAndBetVal(numArea: string, coinValue: number) {
		// Reset the array of highlighted numbers
		const bettingNumbers: any[] = [];

		if (parseInt(numArea) < 37) {
			bettingNumbers.push(parseInt(numArea));
		} else if (numArea === '_1_12') {
			for (let i = 1; i <= 12; i++) {
				bettingNumbers.push(i);
			}
		} else if (numArea === '_2_12') {
			for (let i = 13; i <= 24; i++) {
				bettingNumbers.push(i);
			}
		} else if (numArea === '_3_12') {
			for (let i = 25; i <= 36; i++) {
				bettingNumbers.push(i);
			}
		} else if (numArea === '_1_18') {
			for (let i = 1; i <= 18; i++) {
				bettingNumbers.push(i);
			}
		} else if (numArea === '_2_18') {
			for (let i = 19; i <= 36; i++) {
				bettingNumbers.push(i);
			}
		} else if (numArea === '_even') {
			for (let i = 1; i <= 36; i++) {
				if (i % 2 === 0) {
					bettingNumbers.push(i);
				}
			}
		} else if (numArea === '_odd') {
			for (let i = 1; i <= 36; i++) {
				if (i % 2 !== 0) {
					bettingNumbers.push(i);
				}
			}
		} else if (numArea === '_red') {
			for (let i = 0; i < GameConfig.reds.length; i++) {
				bettingNumbers.push(GameConfig.reds[i]);
			}
		} else if (numArea === '_dark') {
			for (let i = 0; i < GameConfig.blacks.length; i++) {
				bettingNumbers.push(GameConfig.blacks[i]);
			}
		} else if (numArea === '_2_1_1') {
			for (let i = 1; i <= 36; i++) {
				if (i % 3 === 1) {
					bettingNumbers.push(i);
				}
			}
		} else if (numArea === '_2_1_2') {
			for (let i = 1; i <= 36; i++) {
				if (i % 3 === 2) {
					bettingNumbers.push(i);
				}
			}
		} else if (numArea === '_2_1_3') {
			for (let i = 1; i <= 36; i++) {
				if (i % 3 === 0) {
					bettingNumbers.push(i);
				}
			}
		} else if (
			numArea === '_1to6' ||
			numArea === '_4to9' ||
			numArea === '_7to12' ||
			numArea === '_10to15' ||
			numArea === '_13to18' ||
			numArea === '_16to21' ||
			numArea === '_19to24' ||
			numArea === '_22to27' ||
			numArea === '_25to30' ||
			numArea === '_28to33' ||
			numArea === '_31to36'
		) {
			const fN = Number(numArea.split('_')[1].split('to')[0]);
			const sN = Number(numArea.split('to')[1]);
			for (let i = fN; i <= sN; i++) {
				bettingNumbers.push(i);
			}
		} else {
			const btn2h = numArea.split('_')[1].split('n');
			for (let i = 0; i < btn2h.length; i++) {
				bettingNumbers.push(parseInt(btn2h[i]));
			}
		}

		return {
			nums: bettingNumbers,
			betVal: coinValue / bettingNumbers.length
		};
	}
	// NEW
	private getBetDetails(numArea: string, coinValue: number): BetEntry | null {
		const target = numArea.replace(/^_/, '');
		const numbers: number[] = [];
		let type: BetEntry['type'] = 'straight';

		// Primeiro validações por tipo (ordem importa!)
		if (target === '1_12') {
			type = 'dozen';
			for (let i = 1; i <= 12; i++) numbers.push(i);
		} else if (target === '2_12') {
			type = 'dozen';
			for (let i = 13; i <= 24; i++) numbers.push(i);
		} else if (target === '3_12') {
			type = 'dozen';
			for (let i = 25; i <= 36; i++) numbers.push(i);
		} else if (target === '1_18') {
			type = 'highLow';
			for (let i = 1; i <= 18; i++) numbers.push(i);
		} else if (target === '2_18') {
			type = 'highLow';
			for (let i = 19; i <= 36; i++) numbers.push(i);
		} else if (target === 'even') {
			type = 'oddEven';
			for (let i = 2; i <= 36; i += 2) numbers.push(i);
		} else if (target === 'odd') {
			type = 'oddEven';
			for (let i = 1; i <= 35; i += 2) numbers.push(i);
		} else if (target === 'red') {
			type = 'color';
			numbers.push(...GameConfig.reds);
		} else if (target === 'dark') {
			type = 'color';
			numbers.push(...GameConfig.blacks);
		} else if (target === '2_1_1') {
			type = 'column';
			for (let i = 1; i <= 36; i++) if (i % 3 === 1) numbers.push(i);
		} else if (target === '2_1_2') {
			type = 'column';
			for (let i = 1; i <= 36; i++) if (i % 3 === 2) numbers.push(i);
		} else if (target === '2_1_3') {
			type = 'column';
			for (let i = 1; i <= 36; i++) if (i % 3 === 0) numbers.push(i);
		} else if (target.includes('to')) {
			type = 'range';
			const [from, to] = target.split('to').map(Number);
			for (let i = from; i <= to; i++) numbers.push(i);
		} else if (/^\d+$/.test(target)) {
			// Agora sim: só considera straight se o target for puramente numérico
			type = 'straight';
			numbers.push(Number(target));
		} else {
			// fallback: pode ser uma seleção múltipla como '10n13n15'
			const parts = target.split('n').map(Number);
			numbers.push(...parts);
			type = 'range';
		}

		return {
			type,
			target,
			numbers,
			amount: coinValue
		};
	}

	private checkBalanceValue(coinValue: number) {
		return this.scene.rouletteBalanceValue >= coinValue;
	}

	// PUBLIC ------
	// OLD
	/*public checkMaximumBet(): boolean {
		for (const value of this.bets.values()) {
			if (value >= GameConfig.maxBet) return true;
		}
		return false;
	}*/
	public checkMaximumBet(): boolean {
		const totalBet = this.bets.reduce((sum, bet) => sum + bet.amount, 0);
		return totalBet >= GameConfig.maxBet;
	}

	// FUTURE
	/*public checkBetByType(type: string, target: string): boolean {
		const totalOnType = this.bets.filter(b => b.type === type && b.target === target).reduce((sum, b) => sum + b.amount, 0);
		return totalOnType >= GameConfig.maxBetPerType;
	}*/

	public getBets(): BetEntry[] {
		return [...this.bets];
	}

	// OLD
	/*public setBetsSnapshot(snapshot: { [key: string]: number }) {
		this.bets = new Map();
		for (const key in snapshot) {
			if (snapshot.hasOwnProperty(key)) {
				this.bets.set(key, snapshot[key]);
			}
		}
	}*/

	// NEW
	public setBetsSnapshot(snapshot: BetEntry[]) {
		this.bets = [...snapshot];
	}

	public getBetsSnapshot(): BetEntry[] {
		return [...this.bets];
	}

	public clearBets(restore: boolean = false) {
		if (restore) {
			// Devolve o valor apostado ao saldo (caso o jogador esteja apenas cancelando a aposta)
			this.scene.rouletteBalanceValue += this.scene.rouletteBetValue;
			this.scene.rouletteBalance.setText(`Balance: ${this.scene.rouletteBalanceValue}`);
		}

		this.bets = [];
		this.scene.rouletteBetValue = 0;
		this.scene.rouletteBet.setText(`Bet: 0`);
	}

	// NEW
	public addBet(numberArea: string, coinValue: number) {
		const num = numberArea.split('b')[1];
		const bet = this.getBetDetails(num, coinValue);

		if (!bet || !this.checkBalanceValue(coinValue) || this.checkMaximumBet()) return;

		this.scene.rouletteBalanceValue -= coinValue;
		this.scene.rouletteBetValue += coinValue;
		this.scene.rouletteBalance.setText(`Balance: ${this.scene.rouletteBalanceValue}`);
		this.scene.rouletteBet.setText(`Bet: ${this.scene.rouletteBetValue}`);

		// 👇 Verifica se já existe uma aposta igual (mesmo tipo e target)
		const existingBet = this.bets.find(b => b.type === bet.type && b.target === bet.target);

		if (existingBet) {
			existingBet.amount += coinValue; // acumula
		} else {
			this.bets.push(bet); // adiciona nova
		}

		console.log(this.bets, JSON.stringify(this.bets), 'ADD');
	}

	// NEW
	public removeBet(numberArea: string, coinValue: number) {
		const num = numberArea.split('b')[1];
		const bet = this.getBetDetails(num, coinValue);

		if (!bet) return;

		this.scene.rouletteBalanceValue += coinValue;
		this.scene.rouletteBetValue -= coinValue;
		this.scene.rouletteBet.setText(`Bet: ${this.scene.rouletteBetValue}`);
		this.scene.rouletteBalance.setText(`Balance: ${this.scene.rouletteBalanceValue}`);

		const index = this.bets.findIndex(b => b.type === bet.type && b.target === bet.target && b.amount === bet.amount);

		if (index !== -1) this.bets.splice(index, 1);

		console.log(this.bets, 'REMOVE');
	}

	public resolveAndApplyWinnings(result: number): number {
		const payoutTable: Record<BetEntry['type'], number> = {
			straight: 36,
			color: 2,
			oddEven: 2,
			dozen: 3,
			column: 3,
			highLow: 2,
			range: 2
		};

		let totalWin = 0;

		for (const bet of this.bets) {
			if (bet.numbers.includes(result)) {
				const payout = payoutTable[bet.type] || 0;
				const unitBet = bet.amount / bet.numbers.length;

				// 👇 Arredondar para garantir ficha inteira no ganho
				const won = Math.floor(unitBet * payout);
				totalWin += won;
			}
		}

		return totalWin; // também será inteiro
	}
}
